module.exports = __webpack_public_path__ + "img/enquiryStep.13ce66be.png";